export enum TranslationMode {
    SuggestAutomatic = 0,
    Automatic = 1,
    Never = 2,
    Suggest = 3,
}
